import { jsx } from "react/jsx-runtime";
import { TextareaInput, TextInput } from "@contember/ui";
import { useFieldControl } from "./useFieldControl.js";
import { SimpleRelativeSingleField } from "../auxiliary/SimpleRelativeSingleField/SimpleRelativeSingleField.js";
const parse = (value) => value ?? null;
const format = (value) => value ?? null;
const TextField = SimpleRelativeSingleField(
  (fieldMetadata, {
    allowNewlines,
    label,
    wrapLines,
    ...props
  }) => {
    const inputProps = useFieldControl({
      ...props,
      fieldMetadata,
      parse,
      format
    });
    return allowNewlines || wrapLines ? /* @__PURE__ */ jsx(TextareaInput, { ...inputProps }) : /* @__PURE__ */ jsx(TextInput, { ...inputProps });
  },
  "TextField"
);
export {
  TextField
};
//# sourceMappingURL=TextField.js.map
